import Highcharts from "./highchartsSetup";
import HighchartsReact from "highcharts-react-official";
import HighchartsHeatmap from "highcharts/modules/heatmap";
import {forwardRef} from "react";
HighchartsHeatmap(Highcharts);

interface CustomHeatmapProps extends HighchartsReact.Props {
    width?: number;
    height?: number;
    legend?: Highcharts.LegendOptions;
    isInverted?: boolean;
}

const CustomHeatmapChart = forwardRef<HighchartsReact.RefObject, CustomHeatmapProps>(({ series, yAxis, xAxis, colorAxis, small = false, width, height, tooltip, legend, isInverted = false, ...rest }, ref) => {
    const chartHeight = small ? (yAxis.categories.length * 35) + 180 : xAxis.categories.length > 5 ? (yAxis.categories.length * 50) + 150 : (yAxis.categories.length * 55) + 180;
    const chartWidth = xAxis.categories.length > 5 ?(xAxis.categories.length * 50) + 250 : (xAxis.categories.length * 55) + 250;

    const options: Highcharts.Options = {
        accessibility: {
            enabled: false,
        },
        tooltip: tooltip,
        chart: {
            inverted: isInverted,
            type: "heatmap",
            backgroundColor: "transparent",
            borderWidth: 0,
            plotBorderWidth: 0,
            borderColor: "#fff",
            height: height ?? chartHeight,
            width: width ?? chartWidth,
            style: {
                fontFamily: "'Rubik', 'Helvetica Neue', Arial, sans-serif",
            },
        },
        title: {
            text: "",
        },
        plotOptions: {
            series: {
                // @ts-ignore
                pointWidth: 40,
            }
        },
        colorAxis: {
            min: 0,
            minColor: '#eef1f8',
            maxColor: '#002D96',
        },
        exporting: {
            enabled: false, // hides the export menu button
        },
    }

    return (
        <HighchartsReact highcharts={Highcharts} options={{ ...options, series, yAxis, xAxis, colorAxis, tooltip, legend, isInverted }} ref={ref} {...rest} />
    )
});

export default CustomHeatmapChart;